import Api from '@/services/api.js';

export default {
  addTip(details) {
    return Api.post('tips/', details);
  },
  getAllTips() {
    return Api.get('tips/');
  },
  deleteTip(tip) {
    return Api.delete(`tips/${tip}`);
  },
  updateTip(tip) {
    var tipId = tip.id;
    return Api.put(`tips/${tipId}`, tip);
  },
  getTipsByProject(project) {
    return Api.get('tips/byProject/' + project);
  },
}